// Models
import {
  FeatureFlags,
  FeatureFlagsActionTypes,
} from 'app/shared/featureFlags/models';

// Utils
import { createAction, ActionsUnion } from 'app/shared/utils/action-helpers';

export const setFeatureFlags = (payload: FeatureFlags) => {
  return createAction(FeatureFlagsActionTypes.SET_FEATURE_FLAGS, payload);
};

// only needed for typing in the reducer
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ReduxActions = {
  setFeatureFlags,
};

export type FeatureFlagActions = ActionsUnion<typeof ReduxActions>;
